const mobileStyle = Object.freeze({
  menuHeight: '10rem',
});

export default mobileStyle;
